module.exports = __webpack_public_path__ + "img/footerbkg.9f154603.jpg";